import React from 'react';
import { FC } from 'react';

import { CheckType } from '@shared/comparison_matrix';
import { ResponsiveBreak } from '@shared/responsive_breaks';
import { ServiceSelection } from '@shared/service_selector/constants';

import ICON from '@images/illustrations/clutter_truck.svg';

import { ProductComparison } from './product_comparison';

const SERVICE_FEATURES = [
  {
    serviceName: 'Truck',
    clutter: CheckType.Check,
    competitor1: CheckType.Check,
    competitor2: CheckType.Check,
  },
  {
    serviceName: 'Packing supplies',
    clutter: CheckType.Check,
    competitor1: CheckType.Check,
    competitor2: CheckType.Check,
  },
  {
    serviceName: 'Packing help',
    clutter: CheckType.Check,
    competitor1: CheckType.Check,
    competitor2: CheckType.X,
  },
  {
    serviceName: 'Furniture protection',
    clutter: CheckType.Check,
    competitor1: CheckType.Check,
    competitor2: CheckType.X,
  },
  {
    serviceName: 'Disassembly & reassembly',
    clutter: CheckType.Check,
    competitor1: CheckType.Check,
    competitor2: CheckType.X,
  },
  {
    serviceName: 'Reliable movers',
    clutter: CheckType.Check,
    competitor1: CheckType.Check,
    competitor2: CheckType.X,
  },
  {
    serviceName: 'Professional driver',
    clutter: CheckType.Check,
    competitor1: CheckType.Check,
    competitor2: CheckType.X,
  },
  {
    serviceName: 'Track your truck online',
    clutter: CheckType.Check,
    competitor1: CheckType.X,
    competitor2: CheckType.X,
  },
  {
    serviceName: 'Digital walkthrough',
    clutter: CheckType.Check,
    competitor1: CheckType.X,
    competitor2: CheckType.X,
  },
  {
    serviceName: 'Online move management',
    clutter: CheckType.Check,
    competitor1: CheckType.X,
    competitor2: CheckType.X,
  },
  {
    serviceName: 'Accurate quote',
    clutter: CheckType.Check,
    competitor1: CheckType.X,
    competitor2: CheckType.X,
  },
];

export const MovingProductComparison: FC<{
  title: string;
}> = ({ title }) => (
  <ProductComparison
    title={title}
    legend={[
      { icon: ICON },
      {
        name: (
          <>
            Local <ResponsiveBreak mode="only" sm />
            Movers
          </>
        ),
      },
      {
        name: (
          <>
            U-Haul <ResponsiveBreak mode="only" sm />
            Moving
          </>
        ),
      },
    ]}
    serviceFeatures={SERVICE_FEATURES}
    service={ServiceSelection.Moving}
  />
);
